module.exports = __webpack_public_path__ + "img/ercode_gx.38860f52.png";